import React, { useEffect } from 'react';
import css from './SectionInstagramPosts.module.css';

const SectionInstagramPosts = () => {
  useEffect(() => {
    // Dynamically load the EmbedSocial script
    const script = document.createElement('script');
    script.src = 'https://embedsocial.com/cdn/ht.js';
    script.id = 'EmbedSocialHashtagScript';
    document.head.appendChild(script);

    return () => {
      // Cleanup the script when the component unmounts
      document.head.removeChild(script);
    };
  }, []);

  return (
    <section className={css.section}>
      <div
        className='embedsocial-hashtag'
        data-ref="be60f61e223360b7c9b98e136f4f5b6f4a59ba06"
        data-lazyload="no"
      >
        <a
          className="feed-powered-by-es"
          href=""
          target="_blank"
          title=""
        >
        </a>
      </div>
    </section>
  );
};

export default SectionInstagramPosts;
